$(document).ready(function() {
    var session_key = 'exclVAT';
    var session_val = sessionStorage.getItem(session_key);

    if (session_val == null) {
        session_val = false;
        sessionStorage.setItem(session_key, session_val);
    } else {
        session_val = (session_val == 'true');
    }

    $('#price-toggle').prop('checked', session_val);
    setPrice();
    $('#price-toggle').on('change', function() {
        setPrice();
    });

    function setPrice() {
        session_val = $('#price-toggle').prop('checked'); // Update Session Value

        sessionStorage.setItem(session_key, session_val); // Update prices in frontend

        $('[data-price-wrapper]').each(function(i, p) {
            if (session_val) {
                // Show without VAT Price
                $(p).find('.in-vat').addClass('hidden');
                $(p).find('.ex-vat').removeClass('hidden');
                // console.log('vat');
            } else {
                // Show VAT Price
                $(p).find('.ex-vat').addClass('hidden');
                $(p).find('.in-vat').removeClass('hidden');
                // console.log('ex');
            }
        });
    }
});
